import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
    {
        path: '/alumniService',
        component: LAYOUT,
        redirect: '/alumniService/infoService',
        meta: { title: '校友服务', showNavPanel: true },
        children: [
            {
                path: 'consultService',
                name: '咨询服务',
                component: () => import('@/views/alumniService/consultService.vue'),
                meta: { title: '咨询服务' },
            },
            {
                path: 'competition',
                name: '双创大赛',
                component: () => import('@/views/alumniService/competition.vue'),
                meta: { title: '双创大赛' },
            },
            {
                path: 'lifeStudy',
                name: '继续教育',
                component: () => import('@/views/alumniService/lifeStudy.vue'),
                meta: { title: '继续教育' },
            },
            {
                path: 'infoService',
                name: '信息化服务',
                component: () => import('@/views/alumniService/infoService.vue'),
                meta: { title: '信息化服务' },
            },
            {
                path: 'infoPractical',
                name: '实用信息',
                component: () => import('@/views/alumniService/infoPractical.vue'),
                meta: { title: '实用信息' },
            },
        ],
    },
]
